module directives {
    export module compliance {
        interface IImportComplianceSLAMetricsScope extends ng.IScope {
            complianveSLAMetricsData: interfaces.compliance.IComplianceDashboardMissingDocumentsSummary[];
            isLoading: boolean;
            LoadComplianceSLAMetricsData();
            downloadExcel();
        }

        export class importComplianceSLAMetricsDirective implements ng.IDirective {
            templateUrl = 'templates/modules/applicationmain/compliance/importComplianceSLAMetricsView.html';
            scope = {
            }

            public complianveSLAMetricsData: interfaces.compliance.IComplianceDashboardMissingDocumentsSummary[];

            constructor(
                private generalService: interfaces.applicationcore.IGeneralService,
                private $state: ng.ui.IStateService,
                private bsLoadingOverlayService,
                private consignmentTemplateService: interfaces.compliance.IConsignmentTemplateService,
            ) {
                   
            }

            link = ($scope: IImportComplianceSLAMetricsScope, $element: ng.IAugmentedJQuery, $state) => {
                var filterList: interfaces.applicationcore.IKeyValue[] = [];
                var searchList: interfaces.applicationcore.IKeyValue[] = [];
                
                $scope.LoadComplianceSLAMetricsData = () => {
                    $scope.isLoading = true;
                    return this.consignmentTemplateService.getComplianceDashboardMissingDocsSummary(true).query({
                    }, (resultList) => {
                            $scope.complianveSLAMetricsData = resultList;
                        $scope.isLoading = false;
                    }).$promise;
                }

                $scope.LoadComplianceSLAMetricsData();       

                $scope.downloadExcel = () =>{
                    $scope.isLoading = true;
                    this.consignmentTemplateService.getComplianceDashboardMissingDocsDetailExcel(true).then(() => {
                        $scope.isLoading = false;
                    }, (data) => {
                        $scope.isLoading = false;
                    });
                }
                
            }

            static factory(): ng.IDirectiveFactory {
                const directive = (generalService, $state,
                    bsLoadingOverlayService, consignmentTemplateService) => new importComplianceSLAMetricsDirective(generalService, $state, bsLoadingOverlayService,consignmentTemplateService);
                directive.$inject = ["generalService", "$state", "bsLoadingOverlayService","consignmentTemplateService"];

                return directive;
            }
        }

        angular.module("app").directive("gtsComplianceImportsla", importComplianceSLAMetricsDirective.factory());
    }
}